<template>

  <el-container style="height: 100%;">
      <el-menu  class="el-menu-vertical" :collapse="isCollapse" :default-active="isSelect.toString()" :default-openeds="[isSelect.toString()]"  :unique-opened = "true" :router="true">

        <el-menu-item  v-for="(item,index) in menus" v-if="item.children==undefined" :key="index" :index="item.id.toString()" :route="item.url">

          <i :class="item.ico"></i>
          <span slot="title">{{ item.name }}</span>

        </el-menu-item>
        <el-submenu  v-for="(item,index) in menus" v-if="item.children!=undefined"   :key="index" :index="item.parentId.toString()" >
          <template slot="title">
            <i :class="item.ico"></i><span slot="title">{{ item.name }}</span>
          </template>

          <el-menu-item v-for="(items,index) in item.children" :key="index" :index="items.id.toString()" :route="item.url">

            {{ items.name }}

          </el-menu-item>


        </el-submenu>
      </el-menu>



    <el-container style="width: 100px;">
    	
          	
      <el-header >

        <i :class="icon" @click="setmenu()"></i>
        <h1>太原市互联网租赁自行车服务质量信誉考核信息管理平台</h1>

        <el-dropdown @command="setlogout()">
          <el-avatar :size="40" :src="circleUrls">
          </el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span>{{newdata}}</span>
      </el-header>

      <el-main>
      	<div class="jin_zz" v-if="is_zz"></div>
        <router-view :userphone="userphone"></router-view>
      </el-main>
    </el-container>
  </el-container>

</template>
<script>
import {rem} from '../../assets/js/rem'
export default ({
    name:"Main",
    data(){
      return {
      					is_zz:false,
                newdata:'',
                circleUrls:'',
                isCollapse:false,
                icon:"el-icon-s-fold",
                curIds:'',
                menus:[],
                isSelect:'',
                userphone:''
            }
    },
         beforeRouteEnter(to,from,next){

             next((vm)=>{
               vm.Setis();
             });
         },
        created(){

          this.isLogin();
          this.getUserMenus();
        },
        mounted () {
        	if(localStorage.getItem('is_demo')){
						this.is_zz = true
					}else{
						this.is_zz = false
					}
          window.setInterval(() => {
              this.getdata()
          }, 1000)
          this.getUserInfo();
        },
        methods: {
          Setis(){
            this.isSelect =  this.$route.meta.id;
               console.log(this.$route.meta);

          },
          getdata(){
            let myDate = new Date();
            let year = myDate.getFullYear(); //获取当前年
            let mon = myDate.getMonth() + 1; //获取当前月
            let date = myDate.getDate(); //获取当前日
            let h = myDate.toLocaleTimeString();//获取当前小时数(0-23)前秒
            let week = myDate.getDay();
            let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            this.newdata = year + "年" + mon + "月" + date + "日      " + weeks[week] +"      "+ h
          },
          setmenu(){
             if(this.isCollapse==false){
               this.isCollapse=true;
               this.icon='el-icon-s-unfold';
             }else {
               this.isCollapse=false;
               this.icon='el-icon-s-fold';
             }
          },
          //判断登录
          isLogin(){
            let that = this;
            this.$axios.defaults.withCredentials = true;
            this.$axios
              .get('/api/isLogin')
              .then(function (res) {
								console.log(res)
                if(res.data.data==false){
                  that.$message.error("登录超时");
                  window.setTimeout(() => {
                     that.$router.push({name:'Alogin'})
                  }, 1000);
                }
              }).catch(function (error) { // 请求失败处理
              console.log("服务器错误"+error);
            });
          },

          getUserMenus(){
            var that = this;
            this.$axios.defaults.withCredentials = true;
            this.$axios
              .get('/api/menu/getUserMenus')
              .then(function (res) {
             //  console.log(res.data.data)
                if(res.data.code==200){
                  that.menus = res.data.data;
                }
              }).catch(function (error) { // 请求失败处理
              console.log("服务器错误"+error);
            });
          },

          getUserInfo(){
            let that = this;
            this.$axios.defaults.withCredentials = true;
            this.$axios
              .get('/api/user/getUserInfo')
              .then(function (res) {

                if(res.data.code==200){

                  that.name = res.data.data.userName;
                  that.circleUrls=res.data.data.avatar;
                  that.userphone=res.data.data.phone;

                }else{
                  that.$message.error(res.data.msg);
                }
              }).catch(function (error) { // 请求失败处理
              console.log("服务器错误"+error);
            });
          },

          setlogout(){
            let that = this;
            this.$axios.defaults.withCredentials = true;
            this.$axios
              .get('/api/logout')
              .then(function (res) {
                if(res.data.code==200){
                  that.$message({
                    message: '退出成功',
                    type: 'success'
                  });
                  localStorage.removeItem('is_demo')
                  window.setTimeout(() => {
                    that.$router.push({name:'Alogin'})
                  }, 1000);
                }else {
                  that.$message.error('退出失败');
                }

              }).catch(function (error) { // 请求失败处理
              console.log("服务器错误"+error);
            });
          },


        },

        watch: {

        },


})
</script>

<style>
@import '../../assets/css/astyle.css';
.el-main{
	position: relative;
}
.el-header{
	position: relative;
	z-index: 99;
}
.jin_zz{
	width: 85%;
	height:85%;
	position: fixed;
	bottom:0 ;
	right: 15px;
	background: transparent;
	z-index: 9999999999999;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Main.vue